import { api } from '../../lib/api.ts';

export interface TalkingPoint {
  id: string;
  agendaItemId: string;
  authorId: string;
  authorName: string;
  authorRole: string;
  text: string;
  createdAt: string;
  updatedAt: string;
}

export const talkingPointsApi = {
  async list(meetingId: string, itemId: string): Promise<TalkingPoint[]> {
    const { data } = await api.get<{ points: TalkingPoint[] }>(`/meetings/${meetingId}/items/${itemId}/talking-points`);
    return data.points;
  },
  async upsert(meetingId: string, itemId: string, councilorId: string, text: string): Promise<TalkingPoint | null> {
    const { data } = await api.put<{ point: TalkingPoint | null }>(`/meetings/${meetingId}/items/${itemId}/talking-points`, { councilorId, text });
    return data.point;
  },
};
